module.exports = __webpack_public_path__ + "static/WEDDING E&M-167-40802eeb26953c3b6787ea409b44669a.jpg";